import React from 'react'
import { Navigate, useSearchParams } from 'react-router-dom'

/**
 * Handles links of the form /sag?sagsId=<id> (used in emails) and redirects
 * to the case details page.
 */
export const CaseRedirect: React.FC = (): JSX.Element => {
    const [searchParams] = useSearchParams()

    const sagsId = searchParams.get('sagsId')

    if (!sagsId) {
        return <Navigate replace to="/mine-lonindplaceringer" />
    }

    return (
        <Navigate
            replace
            to={`/mine-lonindplaceringer/sag/${encodeURIComponent(sagsId)}`}
        />
    )
}
